import css from './Secoes.module.css';

/** Um passo numerado ("1 · Envie o SPED"). Usado na landing e nos guias. */
export function Passo({
  numero,
  titulo,
  texto,
}: {
  numero: string;
  titulo: string;
  texto: string;
}) {
  return (
    <li className={css.passo}>
      <span className={css.numeroPasso} aria-hidden="true">
        {numero}
      </span>
      <h3 className={css.tituloPasso}>{titulo}</h3>
      <p className={css.textoPasso}>{texto}</p>
    </li>
  );
}

/** Lista de passos em grade (vira coluna no celular). */
export function ListaPassos({
  children,
  vertical,
}: {
  children: React.ReactNode;
  /** Um embaixo do outro, ligados por uma linha (coluna estreita de artigo). */
  vertical?: boolean;
}) {
  return (
    <ol className={vertical ? `${css.passos} ${css.passosVertical}` : css.passos}>
      {children}
    </ol>
  );
}
